import { render, staticRenderFns } from "./FlipCards.vue?vue&type=template&id=d7f031ea&"
import script from "./FlipCards.vue?vue&type=script&lang=js&"
export * from "./FlipCards.vue?vue&type=script&lang=js&"
import style0 from "./FlipCards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports